import styled from "styled-components";

export const FileItem = styled.div`
  width: 100%;
  border: 1px solid #104467;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  &:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.05);
  }
`;
